import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import ContestFinalistStore from '../../stores/contest-finalist-store';
import { removeFinalist } from '../../actions/contest-finalist';
import ModalStore from 'contest/stores/modal-store';
import constants from 'contest/data/constants';
import { showModal } from 'contest/actions/modal-store-actions';

const connectFinalistDrawer = (Component) => {
    const ConnectedComponent = connectToStores(
        Component,
        [ContestFinalistStore, ModalStore],
        (context) => {
            const store = context.getStore(ContestFinalistStore);
            return {
                finalists: store.getFinalists(),
                maxFinalists: store.getMaxFinalists(),
                onRemoveFinalist: (userId) => {
                    context.executeAction(removeFinalist, userId);
                },

                onConfirm: () => {
                    context.executeAction(showModal, {
                        modal: constants.SELECT_FINALISTS_MODAL,
                        data: {},
                    });
                },
            };
        }
    );

    ConnectedComponent.contextTypes = {
        getStore: PropTypes.func,
        executeAction: PropTypes.func,
    };

    return ConnectedComponent;
};

export default connectFinalistDrawer;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/connected/connect-finalist-drawer.js